import flatpickr from "flatpickr";
import { Bulgarian } from 'flatpickr/dist/l10n/bg';
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';
import moment from 'moment';
import axios from "axios";

let Reservation = {
    elementFromDate: null,
    elementToDate: null,
    fp: null,
    packages: [],
    priceContainer: null,
    locale: 'en',
    options: {
        mode: "range",
        enableTime: false,
        dateFormat: "d.m.Y",
        allowInput: true,
        "plugins": [new rangePlugin({ input: ".daterangepicker-to-date"})],
        onClose: function (selectedDates, dateStr, instance) {
            Reservation.calculatePrice(selectedDates)
        },
        "locale": {
            "firstDayOfWeek": 1 // start week on Monday
        }
    },
    init: function () {
        this.elementFromDate = document.querySelector('.daterangepicker-from-date')
        this.elementToDate = document.querySelector('.daterangepicker-to-date')
        this.priceContainer = document.querySelector('.price-container')
        if (this.elementFromDate !== null && this.elementToDate !== null) {
            this.initDateRangePicker()
        }

        this.onPackageSelect()
        this.clearDates()
    },
    initDateRangePicker: function () {
        let minDate = "today"
        //let minDate = this.element.dataset['min-date'] ?? null
        let maxDate = this.elementFromDate.dataset['max-date'] ?? null

        this.options.minDate = minDate
        this.options.maxDate = maxDate

        let locales = {
            bg: Bulgarian
        };

        if (typeof locales[this.elementFromDate.dataset['locale']] !== 'undefined') {
            this.options.locale = locales[this.elementFromDate.dataset['locale']]
            this.locale = this.elementFromDate.dataset['locale']
        }

        //this.option["plugins"] = [new rangePlugin({ input: ".daterangepicker-to-date" })];

        this.fp = flatpickr(this.elementFromDate, this.options);

        this.calculatePrice(this.fp.selectedDates)
    },
    initPackages: function (checked) {
        let packagesContainer = document.querySelector('.packages-container')
        if (packagesContainer === null) {
            return false
        }

        let packagesSelector = '.package'
        if (checked === true) {
            packagesSelector += ':checked'
        }
        let children = document.querySelectorAll(".packages-container " + packagesSelector)
        if (!children.length) {
            return false
        }

        this.packages = [];

        children.forEach(function (child) {
            if (!child.disabled && typeof child.dataset !== 'undefined') {
                /*Reservation.packages[child.value] = {
                    id: child.value,
                    price: child.dataset['price'] ?? 0.00,
                    maxPrice: child.dataset['maxPrice'] ?? 0.00,
                    oneTimePrice: child.dataset['oneTimePrice'] ?? 0,
                    perDayPrice: child.dataset['perDayPrice'] ?? 0,
                }*/
                Reservation.packages.push({
                    id: child.value,
                    price: child.dataset['price'] ?? 0.00,
                    maxPrice: child.dataset['maxPrice'] ?? 0.00,
                    oneTimePrice: child.dataset['oneTimePrice'] ?? 0,
                    perDayPrice: child.dataset['perDayPrice'] ?? 0,
                })
            }
        })
    },
    calculatePrice: async function (dates) {
        if (typeof dates === 'undefined' || !dates.length) {
            return false
        }

        this.showSpinner()

        this.initPackages(true)
        let fromDate = moment(dates[0])
        let toDate = moment(dates[1])
        let days = toDate.diff(fromDate, 'days') + 1
        let caravanId = document.querySelector('#caravan_id').value
        let url = this.priceContainer.dataset['url'] ?? null

        let currentPrice = url !== null
            ? await this.getCurrentPrice(url, fromDate.format('DD.MM.YYYY'), toDate.format('DD.MM.YYYY'), caravanId)
            : 0.00

        let packagesPrice = 0;
        if (this.packages.length) {
            for (let i in this.packages) {
                packagesPrice += this.calculatePackagePrice(this.packages[i], days)
            }
        }

        currentPrice += packagesPrice
        currentPrice = currentPrice.toFixed(2)

        if (this.priceContainer === null) {
            return false
        }

        this.priceContainer.classList.remove('d-none')
        this.priceContainer.classList.add('d-flex')

        this.priceContainer.querySelector('.total-price').innerHTML = currentPrice
        document.querySelector('#total-price').value = currentPrice
        document.querySelector('#days').value = days

        this.hideSpinner()
    },
    resetPrice: function () {
        this.priceContainer.classList.remove('d-flex')
        this.priceContainer.classList.add('d-none')
        this.priceContainer.querySelector('.total-price').innerHTML = '0.00'
    },
    calculatePackagePrice: function (currentPackage, days) {
        if (parseInt(days) < 0) {
            days = 0
        }

        if (parseFloat(currentPackage.price) === 0) {
            return 0.00
        }

        if (parseInt(currentPackage.oneTimePrice) === 1) {
            return parseFloat(currentPackage.price)
        }

        if (parseInt(currentPackage.perDayPrice) === 1) {
            let price = parseFloat(currentPackage.price) * days
            if (parseFloat(currentPackage.maxPrice) > 0 && price > parseFloat(currentPackage.maxPrice)) {
                price = parseFloat(currentPackage.maxPrice)
            }

            return price
        }

        return 0.00
    },
    onPackageSelect: function () {
        let packagesContainer = document.querySelector('.packages-container')
        if (packagesContainer === null) {
            return false
        }

        let children = document.querySelectorAll(".packages-container .package")
        if (!children.length) {
            return false
        }

        children.forEach(function (child) {
            child.addEventListener('click', function (e) {
                Reservation.calculatePrice(Reservation.fp.selectedDates)
            })
        })
    },
    showSpinner: function () {
        let spinner = this.priceContainer.querySelector('.price-spinner')
        if (!spinner) {
            return false
        }

        spinner.classList.remove('d-none')
    },
    hideSpinner: function () {
        let spinner = this.priceContainer.querySelector('.price-spinner')
        if (!spinner) {
            return false
        }

        spinner.classList.add('d-none')
    },
    getCurrentPrice: async function (url, fromDate, toDate, caravanId) {
        let data = {
            caravan_id: caravanId,
            from_date: fromDate,
            to_date: toDate,
        }
        let options = {
            headers: {
                'X-CSRF-TOKEN': document.querySelector('[name="csrf-token"]').content
            }
        }

        let currentPrice = 0.00
        await axios.post(url, data, options).then(function (response) {
            if (response.data.status) {
                currentPrice = parseFloat(response.data.price)
            }
        });

        return currentPrice
    },
    clearDates: function () {
        let clearBtn = document.querySelector('.clear-dates')
        if (!clearBtn) {
            return false
        }

        clearBtn.addEventListener('click', function (e) {
            Reservation.fp.clear()
            Reservation.resetPrice()
        })
    }
};

Reservation.init();
